export var MenuLocation;
(function(MenuLocation) {
    MenuLocation["PRIMARY"] = "primary";
    MenuLocation["ACTIONS"] = "actions";
    MenuLocation["SECONDARY"] = "secondary";
    MenuLocation["FOOTER_PRIMARY"] = "footer_primary";
    MenuLocation["FOOTER_SECONDARY"] = "footer_secondary";
    MenuLocation["FOOTER_MORE"] = "footer_more";
    MenuLocation["FOOTER_SOCIAL"] = "footer_social";
    MenuLocation["FOOTER_LEGAL"] = "footer_legal";
    MenuLocation["FOOTER_ACTIONS"] = "footer_actions";
})(MenuLocation || (MenuLocation = {}));

//# sourceMappingURL=MenuLocation.js.map